import type { MqttCatalog, MqttTopicEntry } from "../../types/mqtt";

export function MqttTopicTree({
  catalog,
  selectedPattern,
  onSelect,
  filter,
  onFilterChange,
}: {
  catalog: MqttCatalog;
  selectedPattern: string | null;
  onSelect: (entry: MqttTopicEntry) => void;
  filter: string;
  onFilterChange: (v: string) => void;
}) {
  const q = filter.trim().toLowerCase();

  return (
    <div className="flex h-full flex-col">
      <input
        type="search"
        value={filter}
        onChange={(e) => onFilterChange(e.target.value)}
        placeholder="Filter topics…"
        className="mb-2 w-full rounded-md border border-border-subtle bg-page px-2.5 py-1.5 text-text-primary outline-none focus:border-accent"
        style={{ fontSize: "var(--font-body)" }}
      />
      <div className="flex-1 overflow-y-auto">
        {catalog.domains.map((domain) => {
          const topics = domain.topics.filter(
            (t) =>
              !q ||
              t.pattern.toLowerCase().includes(q) ||
              (t.description ?? "").toLowerCase().includes(q),
          );
          if (!topics.length) return null;

          return (
            <div key={domain.id} className="mb-3">
              <div
                className="mb-1 font-semibold text-text-secondary"
                style={{ fontSize: "var(--font-micro)" }}
              >
                {domain.label}
              </div>
              <ul className="space-y-0.5">
                {topics.map((topic) => {
                  const active = selectedPattern === topic.pattern;
                  return (
                    <li key={topic.pattern}>
                      <button
                        type="button"
                        onClick={() => onSelect(topic)}
                        className={[
                          "w-full rounded-md px-2 py-1.5 text-left font-mono transition-colors",
                          active
                            ? "bg-accent/10 text-accent"
                            : "text-text-primary hover:bg-page",
                        ].join(" ")}
                        style={{ fontSize: "var(--font-micro)" }}
                      >
                        {topic.pattern}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
}
